<template>
  <club-form class="card card-body rounded-top" @added="added" />
</template>

<script>
import ClubForm from '@/components/forms/ClubForm';

// @vuese
// Modal klubu
// @group Club
export default {
  components: { ClubForm },
  methods: {
    added(clubId) {
      this.$router.push({ name: 'club', params: { clubId } });
    }
  }
};
</script>
